import React, {useEffect, useState} from 'react';

async function editType(authFetch, info) {
    return await authFetch(`${process.env.REACT_APP_API_URL}/type/update`, {
        method: 'PUT',
        body: JSON.stringify(info),
    });
}


export default function EditType({authFetch, origType, typeId}) {
    const [user, setUser] = useState([]);

    const [typeName, setTypeName] = useState('');
    // const [units, setUnits] = useState([]);
    const [activeUnits, setActiveUnits] = useState('');
    const [reductionDelay, setReductionDelay] = useState('');
    const [reductionPerHour, setReductionPerHour] = useState('');
    const [reductionHalflife, setReductionHalflife] = useState('');
    const [limit, setLimit] = useState('');


    useEffect(() => {
        const fetchUserProfile = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/user/profile`);
            const data = await response.json();
            setUser(data);
        };

        fetchUserProfile();
    }, [authFetch]);

    // Separate this from the previous useEffect to prevent infinity loop
    useEffect(() => {
        setTypeName(origType.name);
        // setUnits(origType.units);
        setActiveUnits(origType.activeUnits);
        setReductionDelay(String(origType.reductionDelay));
        setReductionPerHour(String(origType.reductionPerHour));
        setReductionHalflife(String(origType.reductionHalflife));
        setLimit(String(origType.limit));
    }, [origType]);

    const userId = user._id;


    const handleSubmit = async e => {
        e.preventDefault();
        await editType(authFetch, {
            typeName,
            activeUnits,
            reductionDelay,
            reductionPerHour,
            reductionHalflife,
            limit,
            userId,
            typeId,
        });
        window.location.href = '/type/' + typeId;
    };


    return (
        <>
            <h2>Edit {origType.name}</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="text" defaultValue={typeName} onChange={e => setTypeName(e.target.value)}/>
                </label>
                <label>
                    <p>Active Units</p>
                    <input type="text" defaultValue={activeUnits} onChange={e => setActiveUnits(e.target.value)}/>
                </label>
                <label>
                    <p>Reduction Delay (minutes)</p>
                    <input type="number" defaultValue={reductionDelay}
                           onChange={e => setReductionDelay(e.target.value)}/>
                </label>
                <label>
                    <p>Reduction Per Hour ({origType.activeUnits})</p>
                    <input type="number" defaultValue={reductionPerHour}
                           onChange={e => setReductionPerHour(e.target.value)}/>
                </label>
                <label>
                    <p>Reduction Halflife (minutes)</p>
                    <input type="number" defaultValue={reductionHalflife}
                           onChange={e => setReductionHalflife(e.target.value)}/>
                </label>
                <label>
                    <p>Limit ({origType.activeUnits})</p>
                    <input type="number" defaultValue={limit} onChange={e => setLimit(e.target.value)}/>
                </label>
                <div>
                    <button type="submit">Edit</button>
                </div>
            </form>
        </>
    );
}